import { createComponent } from '@carvana/merch-components';

export const Wrapper = createComponent('section', {
  className:
    'mx-auto flex max-w-[840px] flex-col gap-4xl px-2xl py-6xl sm:px-3xl sm:py-8xl md:px-0'
});

export const Title = createComponent('h2', {
  className: 'text-text-strong t-heading-2xl sm:t-heading-3xl'
});

export const InnerWrapper = createComponent('div', {
  className: 'flex flex-col gap-4xl text-text-default t-body-md'
});
